import { gql } from '@apollo/client';

export const JOBS_CONTRIBUTING_TO_RELIABILITY_SCORE = gql`
  query JobsContributingToReliabilityScore(
    $userId: String
    $directions: [ReliabilityScoreInfluenceDirection!]
  ) {
    jobsContributingToReliabilityScore(
      userId: $userId
      directions: $directions
    ) {
      id
      tenantId
      clientId
      jobId
      userId
      direction
      createdAt
      updatedAt
      job {
        id
        title
        startDate
        createdAt
        classificationId
        classification {
          id
          name
          classificationGroupId
        }
      }
      client {
        id
        name
      }
    }
  }
`;

export const EXCLUDE_JOB_FROM_RELIABILITY_SCORE = gql`
  mutation ExcludeJobFromReliabilityScore($jobId: String!, $reason: String) {
    excludeJobFromReliabilityScore(jobId: $jobId, reason: $reason)
  }
`;

export const CONVERT_JOB_INFLUENCE_DIRECTION = gql`
  mutation ConvertJobInfluenceDirection($jobId: String!, $userId: String) {
    convertJobInfluenceDirection(jobId: $jobId, userId: $userId) {
      id
      jobId
      userId
      direction
      updatedAt
    }
  }
`;
